module.exports = __webpack_public_path__ + "img/messageNotification.181434ac.svg";